import useSessionStore from "../stores/sessionStore.js";

export default function useTimezone() {
  const user = useSessionStore((s) => s.user);
  return user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
